import { BASE_URL } from '@/lib/data';
const BASE = BASE_URL;

function optimizeExternalUrl(src, width = 600) {
  if (!src) return src;
  // Unsplash: add width parameter
  if (src.includes('images.unsplash.com')) {
    const sep = src.includes('?') ? '&' : '?';
    return `${src}${sep}w=${width}&q=75&fm=webp`;
  }
  // Pexels: replace width parameter
  if (src.includes('images.pexels.com')) {
    let url = src.replace(/&w=\d+/, `&w=${width}`);
    if (!url.includes('&w=')) url += `&w=${width}`;
    return url;
  }
  return src;
}

export function OptimizedImage({ src, alt, className = '', sizes = '100vw', aspectRatio, ...props }) {
  if (!src) return null;

  const fullSrc = src.startsWith('/') ? `${BASE}${src}` : src;
  const isMedia = src.includes('/api/media/');
  const isExternal = src.includes('unsplash.com') || src.includes('pexels.com');

  const displaySrc = isExternal ? optimizeExternalUrl(fullSrc) : fullSrc;

  let srcSet = undefined;
  if (isMedia) {
    const base = src.startsWith('/') ? `${BASE}${src}` : src;
    srcSet = [
      `${base}?size=thumb 300w`,
      `${base}?size=medium 800w`,
      `${base} 1400w`,
    ].join(', ');
  }

  return (
    <img
      src={displaySrc}
      srcSet={srcSet}
      sizes={isMedia ? sizes : undefined}
      alt={alt || ''}
      className={className}
      loading="eager"
      decoding="async"
      fetchpriority="high"
      style={aspectRatio ? { aspectRatio } : undefined}
      {...props}
    />
  );
}
